import "./form-input.style.css";

const FormInput = ({ handleChange, label, ...otherProps }) => (
  <div className="group">
    <input className="input" {...otherProps} onChange={handleChange} />
    {label ? (
      <label
        className={`${
          otherProps.value.length ? "shrink" : ""
        } form-input-label`}
      >
        {label}
      </label>
    ) : null}
  </div>
);

export default FormInput;
